<template>
    <v-container class="fill-height justify-start align-start">
        <v-row>
            <v-col>
                <v-form v-model="valid">
                    <v-card>
                        <v-toolbar>
                            <v-toolbar-title>{{ title }}</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    
                                    <v-text-field variant="outlined" density="compact" label="Username" v-model="username"
                                        :disabled="isUpdateMode" :rules="usernameRules"></v-text-field>
                                    <v-text-field variant="outlined" density="compact" label="Email" :rules="emailRules"
                                        v-model="email"></v-text-field>
                                    <v-text-field variant="outlined" :rules="passwordRules" :type="passwordType" density="compact" label="Password"
                                        v-model="password" v-show="showPassword" :append-inner-icon="passwordIcon"  @click:append-inner="plainPassword()" autocomplete="new-password" ></v-text-field>
                                    <v-text-field variant="outlined" :rules="confirmPasswordRules" :type="confPasswordType" density="compact" label="Confirm Password"
                                        v-model="confPassword" v-show="showPassword" :append-inner-icon="confPasswordIcon"  @click:append-inner="plainConfPassword()"  autocomplete="new-password"></v-text-field>
                                    <v-text-field variant="outlined" density="compact" label="First Name"
                                        v-model="firstName" :rules="nameRules"></v-text-field>
                                    <v-text-field variant="outlined" density="compact" label="Last Name"
                                        v-model="lastName" :rules="nameRules"></v-text-field>
                                    <v-select density="compact" variant="outlined" :items="roles" v-model="role" :rules="roleRules"
                                        label="Role"></v-select>
                                    <v-select density="compact" variant="outlined" :items="stateItems" v-model="state" 
                                        label="Account"></v-select>
                                    <v-text-field variant="outlined" density="compact" label="Created" v-model="createdDate"
                                        disabled></v-text-field>
                                    <v-text-field variant="outlined" density="compact" label="Last login"
                                        v-model="lastLoginDate" disabled></v-text-field>
                                    
                                </v-col>
                                <v-col cols="0" sm="0" md="0" lg="6" xl="8">
                                    <v-row>
                                        <v-col>
                                            <v-card >
                                                <v-toolbar>
                                                    <v-toolbar-title>Group</v-toolbar-title>
                                                    <v-btn variant="elevated" color="primary" class="ml-2 mr-3" @click="showSearchBox" >Add</v-btn>
                                                </v-toolbar>
                                                <v-container :hidden="!showSearchMember">
                                                    <v-row class="justify-space-between" >
                                                        <v-col class="pa-2" lg="6" xl="7">
                                                            <member-combo-box label="Search Member" variant="outlined" clearable item-title="name"
                                                                        item-value="memberId"
                                                                        v-model="selectedMember" ></member-combo-box>
                                                        </v-col>
                                                        <v-col class="pa-2" cols="auto" >
                                                            <v-btn variant="elevated" class="mr-3" @click="hideSearchBox" >Cancel</v-btn>
                                                            <v-btn variant="elevated" color="primary" class="mr-3" @click="assignMember" >Save</v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                                <v-list>
                                                    <v-list-item v-for="item in memberGroups"
                                                        :key="item.memberId"
                                                        class="py-3">
                                                        <v-list-item-title>{{ item.name }}</v-list-item-title>
                                                        <template v-slot:append>
                                                            <v-btn
                                                                color="grey-lighten-1"
                                                                icon="mdi-delete"
                                                                variant="text"
                                                                @click="deleteEnity(item.memberId, item.name)"
                                                            ></v-btn>
                                                        </template>
                                                    </v-list-item>
                                                </v-list>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn variant="elevated" class="ml-2 mr-3" @click="$router.push('/members')">Back</v-btn>
                            <v-btn variant="elevated" color="primary" class="mr-3" @click="save">Save</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-col>
        </v-row>
        <v-dialog max-width="500" v-model="dialogOn">
            <v-card title="Unassigne member">
            <v-card-text>Are you sure you whant to unassigne member {{ defectName }}</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text="Dismist" @click="dialogOn = false"></v-btn>
                <v-btn text="Delete" color="error" @click="confirmDelete"></v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar" >{{ message }}
            <template v-slot:actions>
                <v-btn
                    icon="mdi-close"
                    variant="text"
                    @click="snackbar = false"
                    :timeout="timeout"
                    ></v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>

<script>
import MemberApi from '../services/MemberApi'
import moment from 'moment';
import MemberComboBox from '@/components/MemberComboBox.vue';

export default {
    name: 'ReportEdit',
    data() {
        return {
            id: 0,
            firstName: '',
            lastName: '',
            role: '',
            email: '',
            username: '',
            password: '',
            confPassword: '',
            title: '',
            roles: ['Admin', 'User', 'TeamLead'],
            stateItems: ['Active', 'Inactive'],
            state: 'Inactive',
            created: '',
            lastLogin: '',
            isUpdateMode: true,
            showPassword: false,
            confPasswordIcon: 'mdi-eye',
            confPasswordType: 'password',
            passwordIcon: 'mdi-eye',
            passwordType: 'password',
            valid: false,
            message: "",
            showSearchMember: false,
            selectedMember: null,
            memberGroups: [],
            snackbar: false,
            dialogOn: false,
            timeout: 2000,
            nameRules: [
                value => {
                    if (value) return true
                    return 'Name is required.'
                },
                value => {
                    if (value?.length > 1 && value?.length < 255 ) return true

                    return 'Name must be in between 2 and 255 characters.'
                },
            ],
            emailRules: [
                value => {
                    if (value) return true

                    return 'E-mail is required.'
                },
                value => {
                    if (/.+@.+\..+/.test(value)) return true

                    return 'E-mail must be valid.'
                },
            ],
            usernameRules: [
                value => {
                    if (value) return true

                    return 'Username is required.'
                },
                value => {
                    if (/[a-zA-Z0-9]+([._]?[a-zA-Z0-9]+)*/.test(value)) return true

                    return 'Username must be valid.'
                },
            ],
            passwordRules: [
                (value) => !!value || 'Please type password.',
                (value) => (value && value.length >= 6) || 'minimum 6 characters',
            ],
            confirmPasswordRules: [
                (value) => !!value || 'type confirm password',
                (value) => value === this.password || 'The password confirmation does not match.',
            ],
            roleRules: [
                (value) => !!value || 'Select role.',
                (value) => ( value === 'Admin' || value === 'User' || value === 'TeamLead' )  || 'Invalid Role.',
            ]
        }
    },
    components: {
        MemberComboBox
    },
    computed: {
        createdDate() {
            if (!this.created)
                return ''
            return moment(this.created).format('DD.MM.YYYY HH:mm')
        },
        lastLoginDate() {
            if (!this.lastLogin)
                return ''
            return moment(this.lastLogin).format('DD.MM.YYYY HH:mm')
        }
    },
    mounted() {
        var id = this.$route.params.id;
        this.id = id;
        if (!isNaN(id)) {
            this.title = "Edit";
            this.isUpdateMode = true;
            this.showPassword = false;
            MemberApi.get(this.id).then((response) => {
                if (response.data) {
                    this.firstName = response.data.firstName;
                    this.lastName = response.data.lastName;
                    this.email = response.data.email;
                    this.username = response.data.username;
                    this.role = response.data.role;
                    this.state = response.data.active ? 'Active' : 'Inactive';
                    this.id = response.data.memberId;
                    this.created = response.data.created;
                    this.lastLogin = response.data.lastLogin;

                    if(response.data.operators) {
                        let op = response.data.operators;
                        for(let i in op) {
                            this.memberGroups.push({ memberId: op[i].memberId, name: op[i].name })
                        }
                    }
                }
            }).catch((ex) => {
                console.log(ex);
            })
        }
        else {
            this.title = "Create";
            this.isUpdateMode = false;
            this.showPassword = true;
        }
    },
    methods: {
        save() {
            var operators = null
            if (this.memberGroups) {
                operators = [];
                for(let i in this.memberGroups) {
                    operators.push({ memberId: this.memberGroups[i].memberId  });
                }
            }
            if(!isNaN(this.id) && this.id > 0) {
                MemberApi.put(this.id, {
                        memberId: this.id,
                        username: this.username,
                        email: this.email,
                        firstName: this.firstName,
                        lastName: this.lastName,
                        role: this.role,
                        active: this.state == 'Active' ? true : false,
                        operators: operators
                    }).then((response) => {
                    if (response.data) {
                        this.$router.push('/members/' + this.id);
                        this.message = response.data.state.message;
                        this.snackbar = true;
                    }
                }).catch((ex) => {
                    console.log(ex);
                })
            }
            else {
                MemberApi.post({
                        memberId: 0,
                        username: this.username,
                        email: this.email,
                        firstName: this.firstName,
                        lastName: this.lastName,
                        password: this.password,
                        role: this.role,
                        active: this.state == 'Active' ? true : false,
                        operators: operators
                    }).then((response) => {
                    if (response.data) {
                        this.id = response.data.memberId;
                        this.created = response.data.created;
                        this.$router.push('/members/' + this.id);
                        this.message = response.data.state.message;
                        this.snackbar = true;
                    }
                }).catch((ex) => {
                    console.log(ex);
                })
            }
        },
        formatDate(dt) {
            return moment(dt).format('DD.MM.YYYY HH:mm')
        },
        plainConfPassword() {
            if(this.confPasswordIcon == 'mdi-eye-closed') {
                this.confPasswordIcon = 'mdi-eye'
                this.confPasswordType = 'password'
            }
            else {
                this.confPasswordIcon = 'mdi-eye-closed'
                this.confPasswordType = 'text'
            }
        },
        plainPassword() {
            if(this.passwordIcon == 'mdi-eye-closed') {
                this.passwordIcon = 'mdi-eye'
                this.passwordType = 'password'
            }
            else {
                this.passwordIcon = 'mdi-eye-closed'
                this.passwordType = 'text'
            }
        },
        showSearchBox() {
            this.showSearchMember = true;
        },
        hideSearchBox() {
            this.showSearchMember = false;
        },
        assignMember() {
            if(this.selectedMember == null || this.selectedMember?.memberId == null) {
                this.message = 'Pleas select a member first!';
                this.snackbar = true;
                return;
            }
            
            let item = this.memberGroups.find((a) => a.memberId == this.selectedMember?.memberId);
            
            if(item) {
                this.message = 'Member already present in the list!';
                this.snackbar = true;
                return;
            }
            MemberApi.get(this.selectedMember?.memberId).then((response) => {
                if(response && response.data) {
                    console.l
                    this.memberGroups.push({ memberId: response.data.memberId, name: response.data.firstName + ' ' + response.data.lastName });
                    this.hideSearchBox();
                    this.selectedMember = null;
                    this.save()
                }
            })
            
        },
        deleteEnity(id, code) {
            this.memberId = id;
            this.name = code;
            this.dialogOn = true;
        },
        confirmDelete() {
            var index = this.memberGroups.map(e => e.memberId).indexOf(this.memberId);
            if(index != -1) {
                this.memberGroups.splice(index, 1);
                this.dialogOn = false;
                this.save();
            }
        },
    }
}
</script>